const activityLog = {
  ACTIVITY_LOGS: 'admin/activity-logs',
}

export default activityLog
